const zh = {
  language: {
    name: "ZH",
  },
  title: 'Seat System',
  exit: "Exit",
  code: "Activation code",
  timeInfo: 'Activation code valid for 3 minutes',
  tipe: ' Use this activation code to search for the "seat reservation after passing the exam" mini program on WeChat',
  copy: 'Copy',
  nextTime: "Let's talk about it next time",
  tab: {
    orders: 'Order Seat',
    query: 'Records Search',
  },
  common: {

    error: 'Error',
    success: 'Success!',
    yes: 'Confirm',
    cancel: 'Cancel',
    allFloor: 'All',
    tip: 'Tip',
    closing: 'Closed or full, please choose another time to book',
  },
  language: {
    change: 'Please Select',
    en: 'EN',
    zh: 'ZH',
  },
  //登录页面
  login: {
    welcome: "Welcome to use",
    noticeTitle: "Notice",
    system: "Seat System",
    loginPass: 'Login',
    noNoticeDes: "No notice",
    userNamePle: "Please enter username",
    passwordPle: "Please enter password",
    codePle: "Please enter code",
    codeGet: 'Code',
    loginBtnWord: "Login",
    casBtn: 'Unified Login',
    loginNotice1: "Please enter username and password",
    loginNotice2: "Please enter code"
  },
  IKnow: 'I get',
  orderSeat: {
    orderDate: 'Order Seat',
    orderTime: 'reservation date',
    orderLocation: 'Location',
    orderSeat: 'Seat',
    viewRecords: 'Reserve record'
  },
  //预约页面
  home: {
    selectTitle1: "Build",
    selectTitle2: "Floor",
    selectTitle3: "Date",
    selectTitle4: "Start/End Time",
    selectTitle5: "Other",
    selectDateTabsTitleFragment: 'Time range screening',
    selectDateTabsTitleScope: 'Time period screening',
    selectDateTabsAll: 'All',
    selectDateTabsAm: 'AM',
    selectDateTabsPm: 'PM',

    startTimePlaceHolder: 'Please select start Time',
    endTimePlaceHolder: 'Please select end Time',
    btn: 'Search',
    window: 'Window',
    power: 'Power',
    roomType: 'hour24 seat',
    notice: "Click on the color block to enter the details page for space reservation selection",
    emptyNotice: "There is currently no space to choose from. Please go to the left side to change the filtering options",
    statusNotice2: 'Not available',
    statusNotice1: 'available',
    search: 'Search',
    Monday: 'Mon',
    Tuesday: 'Tue',
    Wednesday: 'Wed',
    Thursday: 'Thu',
    Friday: 'Fri',
    Saturday: 'Sat',
    Sunday: 'Sun',
    build: 'Build',
    floor: 'Floor',
    total: 'Total',
    free: 'Free',
    specialSpace: 'Special space',
    regularSeatmsg: 'Hello, there is no regular seat oh, go to choose a seat ~',
  },
  //我的预约页面
  my: {
    tab1: 'Today Records',
    tab2: 'History Records',
    tab3: 'Default records',
    tab4: 'Access control record',
    tip: 'Click the operation button to modify the record',
    empty: "No more data!",
    totalWord: "data",
    table1: {
      seat: 'Seat',
      date: 'Date',
      time: 'Start/End Time',
      leaveTime: 'Leave/Back Time',
      validateTime: 'Default date',
      validateReason: 'Reason',
      code: 'Voucher number',
      status: 'Status',
      status1: "In performance",
      status2: 'leave early',
      status3: 'temporarily part',
      status4: 'reservation',
      status5: 'Ended',
      status6: 'no-show',
      status7: 'Canceled',
      status8: 'Not stop',
      op: 'Operate',
      op1: 'EndUse',
      op1Message: 'Do you want to end the use?',
      op2: 'Change Record',
      op3: 'Cancel',
      op3Message: 'Do you want to cancel the appointment?',
      op3MessageSuccess: '取消成功!今日还可取消【N】次',
      loseEfficacy: 'Lose efficacy',
    },
    table_access_control: {
      op1: 'Access control name',
      op2: 'Time',
      op3: 'Status',
    },
  },
  //预约详情页面
  detail: {
    jdzl: 'Supervise Leave',
    tip: 'The seat layout diagram can be dragged left and right, enlarged or reduced. Click on the seat to make an appointment~',
    seat1: 'Free',
    seat2: 'Disable',
    seat3: 'Leave',
    power: 'Power',
    window: 'Window',
    computer: 'Computer',
    back: 'Back',
    startTime: 'Start Time',
    now: '',
    endTime: 'End Time',
    endTimePlaceHolder: 'Please select end time!',
    localMessage: 'This seat requires on-site reservation',
    disableMessage: 'This seat is temporarily unavailable for reservation!',
    timeScreening: 'Time screening',
    number: 'number',
    noAvailable: 'No time slot available!',
  },
  //消息提示弹窗
  message: {
    maxNotice: "最多只能输入200字", //最多只能输入200字
    orderNotice: "预约类型不能为空", //预约类型不能为空
    timeNotice: "请选择连续时间", //请选择连续时间
    warning: "操作失败,请稍后重试~~",
    success: "操作成功",
    fail: "接口调用失败，请联系管理员~~",
    login_success: "登录成功",
    notice: "提示",
    noticeContent: "请完善账号信息",
    buttonConfirm: "确定",
    buttonCancel: "取消",
    buttonReject: '拒绝',
    maxTimeInfo: "最大预约时长为0分钟, 请重新选择时长！",
    minTimeInfo: "最大预约时长为0分钟, 请重新选择时长！"
  },
  notice: {
    message: '点击左侧菜单可以切换不同的通知哦~'
  }
};

export default zh;



// WEBPACK FOOTER //
// ./src/common/language/en.js